var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-stack',{attrs:{"gap":"sm"}},[_c('vs-node',{attrs:{"font-weight":"light"},domProps:{"innerHTML":_vm._s(_vm.$t('subscribeText'))}}),_vm._v(" "),_c('sc-newsletter-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }